import type { ErrorResponse } from '@eika-infrastruktur/request';
import type {
    CreateShareSavingsAccountForChildProcess,
    CreateShareSavingsAccountForChildProcessPayload,
} from '@generated-types';
import { createProcess } from '@react-query/services/process';
import { useMutation } from '@tanstack/react-query';

export const useCreateProcess = () => {
    return useMutation<
        CreateShareSavingsAccountForChildProcess,
        ErrorResponse,
        CreateShareSavingsAccountForChildProcessPayload
    >({
        mutationKey: ['process'],
        mutationFn: (payload) => createProcess(payload),
    });
};
